export const ErrMediaTooLarge = new Error("Media too large")
export const ErrMediaInappropriate = new Error("Media inappropriate")
export const ErrMediaNoFaces = new Error("Media no faces")
export const ErrMediaMultipleFaces = new Error("Media has multiple faces")
export const ErrMediaInvalidFormat = new Error("Media invalid format")
